const Types = {
    DEVICES: 'devices',
    STORE_NOTES: 'store-notes',
}

const defaultReport = 'devices'

const Translations = {
    DEVICES: 'devices',
    STORE_NOTES: 'store-notes',
}

export default Types

export { defaultReport, Translations }
